import { Card, Typography, Chip, Stack } from "@mui/material";
import { Box } from "@mui/system";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../../assets/styles/tokens";
import {
  PERCENT_STYLES,
  cleanNumber,
  formatDate,
  formatUsd,
} from "../../../../../../../DashboardDesktop/Anomalies/AnomaliesTabs/Utils/anomaliesColumns";

// ─────────────────────────────────────────────────────────────────────────────

// Decreased By is highlighted red when it exceeds 5000 (matches desktop's
// DecreaseDailyIncomeTable isHighlighted).
const DECREASE_HIGHLIGHT_THRESHOLD = 5000;

interface DecreaseDailyIncomeProps {
  brand_name: string;
  brand_id: string;
  month: string;
  decreasedBy: number | string;
  maxReportedIncome: number | string;
  currentTotalIncome: number | string;
}

export function DecreaseDailyIncomeCard({
  brand_name,
  brand_id,
  month,
  decreasedBy,
  maxReportedIncome,
  currentTotalIncome,
}: DecreaseDailyIncomeProps) {
  const isHighlighted = cleanNumber(decreasedBy) > DECREASE_HIGHLIGHT_THRESHOLD;

  return (
    <>
      <Card
        sx={{
          p: 1,
          borderRadius: spacing.Radius.lg.$value,
          boxShadow: "0px 1px 2px #0A0D120F , 0px 1px 3px #0A0D121A",
          border: "1px solid" + colors.GrayLightMode[200].$value,
          mb: spacing.Spacing.none.$value,
          mt: spacing.Spacing.xl.$value + "!important",
        }}
      >
        {/* Top Row */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            variant="body1"
            sx={{
              color: colors.GrayLightMode[700].$value,
              fontSize: typography.Size.Text.xs.$value,
              fontWeight: typography.Font_weight.Medium.$value,
              mb: spacing.Spacing.md.$value,
            }}
          >
            {brand_name} ({brand_id})
          </Typography>
        </Stack>

        <Stack
          sx={{
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontSize: typography.Size.Text.sm.$value,
              color: colors.GrayLightMode[900].$value,
              mr: spacing.Spacing.xs.$value,
            }}
          >
            Decreased by
          </Typography>
          <Chip
            label={formatUsd(decreasedBy, { minDecimals: 2, maxDecimals: 2 })}
            size="medium"
            sx={{
              borderRadius: spacing.Radius.xs.$value,
              fontSize: typography.Size.Text.md.$value,
              bgcolor: isHighlighted
                ? PERCENT_STYLES.red.bg
                : colors.GrayLightMode[100].$value,
              color: isHighlighted
                ? PERCENT_STYLES.red.color
                : colors.GrayLightMode[900].$value,
              fontWeight: typography.Font_weight.Semibold.$value,
            }}
          />
        </Stack>

        <Stack>
          <Typography
            variant="body1"
            mt={spacing.Spacing.xs.$value}
            mb={spacing.Spacing.md.$value}
            sx={{
              fontSize: typography.Size.Text.sm.$value,
              color: colors.GrayLightMode[900].$value,
            }}
          >
            Brand Action Date:
            <Box
              component="span"
              sx={{
                fontSize: typography.Size.Text.sm.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                ml: spacing.Spacing.xs.$value,
              }}
            >
              {formatDate(month)}
            </Box>
          </Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="space-between"
          mt={spacing.Spacing.xs.$value}
        >
          <Box
            sx={{
              width: "50%",
              borderRight: "1px solid" + colors.GrayLightMode[200].$value,
              pr: spacing.Spacing.md.$value,
            }}
          >
            <Typography
              mb={spacing.Spacing.xs.$value}
              sx={{
                color: colors.GrayLightMode[500].$value,
                fontSize: typography.Size.Text.xs.$value,
              }}
            >
              Max. Reported Total Income
            </Typography>
            <Box>
              <Typography
                sx={{
                  color: colors.GrayLightMode[900].$value,
                  fontSize: typography.Size.Text.md.$value,
                  fontWeight: typography.Font_weight.Semibold.$value,
                  pr: spacing.Spacing.xs.$value,
                }}
              >
                {formatUsd(maxReportedIncome, {
                  minDecimals: 2,
                  maxDecimals: 2,
                })}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              width: "50%",
              pl: spacing.Spacing.md.$value,
            }}
          >
            <Typography
              mb={spacing.Spacing.xs.$value}
              sx={{
                color: colors.GrayLightMode[500].$value,
                fontSize: typography.Size.Text.xs.$value,
              }}
            >
              Current Total Income
            </Typography>
            <Box>
              <Typography
                sx={{
                  color: colors.GrayLightMode[900].$value,
                  fontSize: typography.Size.Text.md.$value,
                  fontWeight: typography.Font_weight.Semibold.$value,
                  pr: spacing.Spacing.xs.$value,
                }}
              >
                {formatUsd(currentTotalIncome, {
                  minDecimals: 2,
                  maxDecimals: 2,
                })}
              </Typography>
            </Box>
          </Box>
        </Stack>
      </Card>
    </>
  );
}
export default DecreaseDailyIncomeCard;
